<template>
    <div id="homeBox" style="text-align: center">
        <div class="flexcenter" id="flexcenter">
            <!--  新增按钮      -->
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="addGoods">新增货位</el-button>
            <div style="margin-right: 20px">
                <span>仓库:</span>
                <el-select
                        size="mini"
                        style="width: 200px ; margin-right:10px;margin-left: 5px"
                        clearable class="input-width"
                        @change="ckchange"
                        v-model="khid"
                        filterable>
                    <el-option
                            v-for="item in ckdata"
                            :key="item.warehouseId"
                            :label="item.warehouseName"
                            :value="item.warehouseId">
                    </el-option>
                </el-select>
                <span>库区:</span>
                <el-select size="mini"
                           clearable
                           style="width: 200px ; margin-right:10px;margin-left: 5px"
                           class="input-width"
                           @focus="kqfocus"
                           @change="kqchange"
                           v-model="pid"
                           filterable placeholder="请选择">
                    <el-option
                            v-for="item in kqdata"
                            :key="item.storekqId"
                            :label="item.storekqName"
                            :value="item.storekqId">
                    </el-option>
                </el-select>
                <!-- 搜索框 -->
                <el-input
                        size="mini"
                        style="width: 200px  "
                        placeholder="请输入搜索内容"
                        v-model="searchData"
                        clearable>
                </el-input>
                <!-- 搜索按钮 -->
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Searchkq" size="mini"></el-button>
            </div>
        </div>
        <!--  父表格  -->
        <el-table
                id="eltable"
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                style="width: 100%"
                row-key="id"
                stripe
                border
                :header-cell-style="{background:'#eef1f6',color:'black',}"
                :header-row-style="{height:'50px'}"
                :highlight-current-row="true"
                @expand-change="expand"
        >
            <el-table-column type="expand"  ref="tree" width="30px" >

                <!--   子表   -->
                <template slot-scope="scope" width="1" style="text-align: center" >
                    <el-table
                            ref="table"
                            size="mini"
                            border
                            :data="scope.row.erbei"
                            :header-cell-style="{background:'#F0FFFF',color:'#000',}"
                    >

                        <el-table-column
                                prop="name"
                                label="名称"
                                align="center"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="pzname"
                                label="物料"
                                align="center"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="pznames"
                                label="品种集合"
                                align="center"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="pztypes"
                                label="单元集合"
                                align="center"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="mj"
                                label="面积(m²)"
                                align="center"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="rl"
                                label="容量(t)"
                                align="center"
                                show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column
                                prop="isbulkcargo"
                                label="是否散装"
                                show-oveflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.erbei}}
                                <span v-if="scope.row.isbulkcargo==0">固态</span>
                                <span v-if="scope.row.isbulkcargo==1">液态</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="kcnum"
                                label="实时存储量(t)"
                                show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column
                                prop="state"
                                label="状态"
                                show-oveflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.state==1">启用</span>
                                <span v-if="scope.row.state==0">未启用</span>
                            </template>
                        </el-table-column>

                        <el-table-column
                                prop="createTime"
                                label="录入时间"
                                show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column
                                label="操作">
                            <template slot-scope="scope" >
                                <div >
                                    <el-button  type="text" size="mini" @click="editson(scope.row)">编辑</el-button>
                                    <el-button style="color:red;" type="text" size="mini" @click="delson(scope.row,scope.$index)">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>

             <!--   父表内容   -->
            </el-table-column>
            <el-table-column
                    prop="khName"
                    label="仓库名称"
                    width="90px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="kqName"
                    label="库区名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="code"
                    label="货位号"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="area"
                    label="区域名"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="mj"
                    label="面积(m²)"
                    width="70px"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    width="70px"
                    prop="rl"
                    label="容量(t)"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="note"
                    width="290px"
                    :label="$t('form_notes')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    width="100"
                    prop="isdangerous"
                    label="是否危险品"
                    show-oveflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.isdangerous==1">是</span>
                    <span v-if="scope.row.isdangerous==0">否</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="state"
                    label="状态"
                    show-oveflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.state==1">启用</span>
                    <span v-if="scope.row.state==0">未启用</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="录入时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="lruName"
                    label="录入人姓名"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    width="170px"
                    label="操作">
                <template slot-scope="scope" >
                    <div >
                        <el-button  type="text" size="mini" @click="editLine(scope.row)">编辑</el-button>
                        <el-button  style="color:red;"  type="text" size="mini" @click="del(scope.row)">删除</el-button>
                        <el-button    type="text" size="mini" @click="addson(scope.row)">新增品种</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20,30,40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>

                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>

            </div>
        </div>

        <!--  新增货位弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="90px"
                width="31.429rem"
                height="300"
                :title="title"
                :visible.sync="productLines"
                v-if="productLines"
        >
            <addGoods :title="title" @clist="clist"  @close="close" :lineList1 = "lineList"  @getList="getList" ></addGoods>
        </el-dialog>

        <!--  新增品种弹窗(子)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="100px"
                width="500px"
                height="300"
                :title="title"
                :visible.sync="flowPath"
                v-if="flowPath"
        >
            <addson @getPzList="getPzList"  @close="close" :editData1="editData" :listid="listid" @getList="getList" :sonId="sonId"
                    :title="title" @furl="furl($event)"></addson>
        </el-dialog>

        <!--  删除货位弹窗(父)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delLine"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delLine"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{delTitle}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delLine = false">取 消</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>

        <!--  删除品种弹窗(子)  -->
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delsonDialog"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delsonDialog"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deldetail}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delsonDialog = false">取 消</el-button>
    <el-button type="primary" @click="submitsondel">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import addGoods from "./component/AddGoods";
    import addson from "./component/AddSon";

    export default {
        name: 'warehouseManage',
        components:{
            addson,
            addGoods
        },

        data(){
            return{
                ckdata:{},
                kqdata:{},
                pzdata:'',
                dydata:{},
                khid:'',
                pid:'',
                lineList:{},
                delLine:false,
                delsonDialog:false,
                flowPath:false,
                maps:new Map(),
                childrenlist:[],
                loading:'',
                editData:{},
                productLines:false,//编辑弹窗
                currentPage:1,
                pageSize:10,
                deldetail:'',
                total:0,
                listid:0,
                baseerp:'',
                delTitle:'',
                searchData:"",
                tableData:[],
                tableHeight:0,//列表高度
                title:'',
                sonId:0,
                zongrl:0,
                timeStamp:'',
                delDialogVisible:false//删除弹框
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){

            this.selectWarehouse()

            this.total = this.tableData.length
            this.$nextTick(()=>{
                this.onResize();
            })
            // this.$refs.deliverlight.toggleRowExpansion(item,false)
            //公共样式
            this.baseerp=baseerp

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            ckchange(val){
                this.pid=''
                this.khid=val

                    this.selectStorekq()

            },
            khidchange(val){

                this.khid=val
            },
            kqfocus(){
                this.selectStorekq()

            },
            async kqchange(val){

                await  this.selectStorekq()
                await setTimeout(() => {
                    //需要定时执行的代码
                    this.pid=val
                    this.kqdata.storekqId=val
                }, 1)

            },
            furl(val){
                this.zongrl =val

            },


            clist(){
                this.tableData.forEach(item=>{
                    this.$refs.deliverlight.toggleRowExpansion(item,false)
                })
                // this.$refs.deliverlight.toggleRowExpansion(item,false)
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度
            heightAuto(){

                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36;

            },

            //关闭弹框
            close(){
                this.flowPath=false
                this.productLines=false
            },
            //页面搜索
            Searchkq(){
                this.getList()
                this.tableData.forEach(item=>{
                    // item
                    this.$refs.deliverlight.toggleRowExpansion(item,false)
                })

                this.currentPage=1
            },
            //分页
            //监听pagesize改变的事件
            handleSizeChange(newsize) {
                //console.log(`每页 ${newsize} 条`);
                //最新的条数（newsize）赋值给 动态的 pageSize
                this.pageSize = newsize;    //动态改变
                this.getList()
                //获取到最新一页显示的数据  重新发送请求
                this.clist()
                //this.dcslist()
            },
            // 监听 页码值 改变的数据
            //监听页码值改变的数据
            handleCurrentChange(newPage) {
                // console.log(`当前页: ${newPage}`);
                //把最新的页码（newPage）赋值给 动态的 currentPage
                this.currentPage = newPage;    //动态改变
                //获取到最新页码值  重新发送请求
                this.getList()
                this.clist()
                //this.dcslist()
            },
            //新增货位
            addGoods(){
                this.title='新增货位'
                this.lineList={
                    id:0,
                    state:1,
                    rl:0,
                    isdangerous:0,
                }
                this.productLines=true

            },
            //新增品种(子)
            addson(val) {
                this.title = '新增品种'
                this.listid = val.id
                this.editData = {
                    rl: '',
                    state: 1,
                    typeid: '',
                    pzid: [],
                    typeid: [],
                    mj:0,
                    isbulkcargo: 1
                }
                this.flowPath = true

            },
            //编辑货位(父)
            editLine(val){
                this.title='编辑货位'
                this.lineList.id = val.id

                // this.getDetails();
                this.productLines=true

            },
            //编辑品种
            editson(val){

                this.title='编辑品种'
                this.listid=val.wzid
                this.sonId=val.id
                this.flowPath=true
            },

            //作废品种(子)
            delson(val){
                this.title='删除'
                this.editData=val
                this.listid=val.wzid
                this.deldetail='是否要删除'
                this.delsonDialog=true
            },
            //品种确认作废(子)
            submitsondel(){
                this.removePm()
                this.delsonDialog=false
            },
            //删除货位(父)
            del(val){
                this.title='删除'
                this.lineList=val
                this.beforeRemove()
                this.delLine=true
            },
            //货位确认作废(父)
            submitdel(){
                this.remove()
                this.clist()
                this.delLine=false
                this.getList()
            },

            // load(tree,treeNode,resolve){
            //     this.maps.set(tree.id, {tree, treeNode, resolve});
            // },

            expand(row,i){
                const isExpend = i.some(r => r.id === row.id) // 判断当前行展开状态

                if (isExpend) {
                    this.listid=row.id
                    this.getPzList()

                } else {
                    return
                }
            },
            // 货位列表
            async getList() {

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    khid:this.khid,
                    pid:this.pid,
                    search:this.searchData,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                }
                let res = await API.getList(params);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.total=res.total

                    this.tableData.forEach(item=>{
                        item.createTime=item.createTime.substring(0,19)
                    })
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            // 品种列表
            async getPzList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id

                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    hwid:this.listid,
                    search:this.Searchdata,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                }
                let res = await API.getPzList(params);

                if (res.code == 1) {
                    this.tableData.forEach(item=>{
                        if(item.id==this.listid){
                            this.$set(item,'erbei',res.data)

                        }
                    })

                    this.tableData.forEach(item=>{
                        item.createTime=item.createTime.substring(0,19)

                    })

                    if (!!val){
                        this.tableData.map(item=>{

                            if(item.id==val){
                                item.rl=this.zongrl
                            }
                        })

                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //仓库下拉
            async selectWarehouse(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                }
                let res = await API.selectWarehouse(params);
                if (res.code == 1) {
                    this.ckdata = res.data
                    // console.log(res.data)

                    let arr =  res.data;
                    this.khid=arr[0].warehouseId
                    this.selectStorekq()
                    this.getList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //库区下拉
            async selectStorekq(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                    khid: this.khid,

                }
                let res = await API.selectStorekq(params);
                if (res.code == 1) {

                    this.kqdata = res.data
                    // console.log(this.kqdata)
                    let arr=[]

                    this.kqdata.map(item=>{
                         arr.push(item.storekqId)
                        })
                    // arr.map((value,i)=>{
                    for (var i = 0; i < arr.length; i++) {
                        if(arr[i]==this.pid){
                            return
                        }else {
                            this.pid=''
                        }
                    }
                    // let arr =  res.data;
                    // this.pid=arr[1].storepid
                    // this.getList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //货位作废验证
            async beforeRemove() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.lineList.id,

                }
                let res = await API.beforeRemove(params);
                if (res.code == 1) {
                    this.delTitle=res.message
                    // this.getList()
                }else {
                    // this.deldetail=res.message
                    this.$message.error(res.message);
                }
            },
            // 货位作废
            async remove() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.lineList.id,

                }
                let res = await API.remove(params);
                if (res.code == 1) {
                    this.getList()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.deltitle=res.message
                    // this.$message.error(res.message);
                }
            },
            // 品种作废
            async removePm() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                }
                let res = await API.removePm(params);
                if (res.code == 1) {
                    this.zongrl=res.kwTotalRl
                    await this.getList()
                    this.getPzList()
                    // this.clist()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.deltitle=res.message
                    // this.$message.error(res.message);
                }
            },


        },
    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /*/deep/.el-table__empty-text {*/
    /*    margin-left: 800px;*/
    /*}*/
    /deep/.el-table__expanded-cell{
        padding: 5px 0px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    /deep/.el-table__header{
        width: 100% !important;
    }
    /deep/.el-table__body{
        width: 100% !important;

    }
    .left{
        width: 17.857rem;
    }
</style>